import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

export default function TextWithTooltip({
  text,
  className,
  style,
  children,
}: {
  text: string;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {children ? (
            <div className="w-full truncate">{children}</div>
          ) : (
            <p className={cn("truncate", className)} style={style}>
              {text}
            </p>
          )}
        </TooltipTrigger>
        <TooltipContent className="max-w-[400px]">{text}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
